import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import { removeAllToastsAction, setIsShuffleRequiredAction } from 'data/reducers';
import { Notifications } from 'types';

export function* shuffleStarted({ type: responseType }: any) {
  try {
    if (responseType === Notifications.SHUFFLE) {
      yield put(setIsShuffleRequiredAction(true));
      yield put(removeAllToastsAction());
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
